import instanceService from './instance'
import { NOTIFICATION_SERVER_URL } from '../helpers/constants'

let instance = instanceService.instance(NOTIFICATION_SERVER_URL)

export const notificationService = {
    sendMessageToClients,
    getNotifications,
}

function sendMessageToClients(data) {
    const options = {
        method: 'POST',
        url: '/bulkSend',
        data
    }
    return instance(options)
}

function getNotifications(data) {
    const options = {
        method: 'POST',
        url: '/list',
        data
    }
    return instance(options)
}
